export default {
  message: {
    hello: '妳好',
    about: '關於',
    welcome: '歡迎',
  },
}
